/**
 * Mirrors com.medprompt.consultation.status.ConsultationStatus
 */
export const ConsultationStatus = Object.freeze({
  NON_EXISTENT: 'NON_EXISTENT',
  RECORDING: 'RECORDING',
  ABANDONED: 'ABANDONED',
  PENDING: 'PENDING',
  INVALID: 'INVALID',
  GENERATING: 'GENERATING',
  SKIPPED: 'SKIPPED',
  EDITING: 'EDITING',
  READY: 'READY',
  QUEUED_FOR_FILING: 'QUEUED_FOR_FILING',
  FILED_AWAY: 'FILED_AWAY',
});
